import React, { Component } from "react";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";

export class LoanApplicationSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        page: 1,
      },
      openDrawer: false,
    };
    this.isAdmin = this.props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
    // search fields
    this.inprogressFields = [
      {
        name: "customerName",
        label: "Name",
        type: "text",
        placeholder: "Customer Name",
      },
      {
        name: "customerApplicationType",
        label: "Customer Type",
        type: "select",
        options: _enum.CUSTOMER_TYPES,
      },
      {
        label: "Mobile No.",
        name: "mobileNumber",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        label: "Application Date",
        name: "applicationDate",
        type: "date",
        placeholder: "Please Enter",
      },
      {
        name: "loanAmount",
        label: "Applied Loan Amount",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        name: "duration",
        label: "Tenure",
        type: "text",
        placeholder: "Please Enter",
      },
      {
        label: "Application Status",
        name: "status",
        type: "select",
        options: _enum.APPLICATION_STATUS,
      },
      // {
      //   name: "startDate",
      //   label: "Start Date",
      //   type: "date",
      //   placeholder: "Start Date",
      // },
      // {
      //   name: "endDate",
      //   label: "End Date",
      //   type: "date",
      //   placeholder: "End Date",
      // },
    ];
    this.sanctionedFields = [
      {
        name: "customerName",
        label: "Name",
        type: "text",
        placeholder: "Customer Name",
      },
      {
        label: "Mobile No.",
        name: "mobileNumber",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        label: "Application Date",
        name: "applicationDate",
        type: "date",
        placeholder: "Please Enter",
      },
      {
        label: "Sanctioned Amount",
        name: "loanAmount",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        label: "ROI",
        name: "sanctionedIRR",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        label: "Sanctioned Loan Tenure",
        name: "duration",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        label: "Application Status",
        name: "status",
        type: "select",
        options: _enum.APPLICATION_STATUS,
      },
      // {
      //   name: "status",
      //   label: "Status",
      //   type: "select",
      //   options: _enum.STATUS_SANCTIONED,
      //   placeholder: "Status",
      // },
    ];
    this.pendingFields = [
      {
        name: "customerName",
        label: "Name",
        type: "text",
        placeholder: "Customer Name",
      },
    ];
    this.approvedFields = [
      {
        name: "customerName",
        label: "Name",
        type: "text",
        placeholder: "Customer Name",
      },
      {
        label: "Mobile No.",
        name: "mobileNumber",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        label: "Application Date",
        name: "applicationDate",
        type: "date",
        placeholder: "Please Enter",
      },
      {
        label: "Sanctioned Amount",
        name: "loanAmount",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        label: "ROI",
        name: "sanctionedIRR",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        label: "Sanctioned Loan Tenure",
        name: "duration",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        label: "Application Status",
        name: "status",
        type: "select",
        options: _enum.APPLICATION_STATUS,
      },
      // {
      //   name: "status",
      //   label: "Status",
      //   type: "select",
      //   options: _enum.STATUS_APPROVED,
      //   placeholder: "Status",
      // },
    ];
    this.rejectedFields = [
      {
        name: "customerName",
        label: "Name",
        type: "text",
        placeholder: "Customer Name",
      },
      {
        name: "mobileNumber",
        label: "Mobile No.",
        type: "number",
        placeholder: "Mobile No.",
      },
      {
        name: "startDate",
        label: "Start Date",
        type: "date",
        placeholder: "Start Date",
      },
      {
        name: "endDate",
        label: "End Date",
        type: "date",
        placeholder: "End Date",
      },
      {
        name: "loanAmount",
        label: "Applied Loan Amount",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        name: "duration",
        label: "Tenure",
        type: "text",
      },
    ];
  }

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let {
      isAdmin,
      inprogressFields,
      sanctionedFields,
      pendingFields,
      approvedFields,
      rejectedFields,
    } = this;
    let { activeKey, downloadExcel } = this.props;
    let { openDrawer } = this.state;
    return (
      <div className="d-flex align-items-center justify-content-end">
        {isAdmin && (
          <div className="action_btn_group text-end">
            <button
              type="button"
              className="btn btn-primary-transparent file_download_btn text-primary"
              onClick={(...args) => downloadExcel(...args)}
            >
              <i className="fa fa-download me-2"></i>
              Download Excel
            </button>
          </div>
        )}
        <button
          type="button"
          className="btn filter_modal_btn"
          onClick={(...args) => this.toggleDrawer(...args)}
        >
          <i class="fa-solid fa-filter me-2"></i>
          <span>Filters</span>
        </button>
        <AppDynamicFilterModal
          key={activeKey}
          open={openDrawer}
          onClose={this.closeDrawer}
          {...(activeKey === "inprogress"
            ? {
                fields: inprogressFields,
              }
            : activeKey === "sanctioned"
            ? {
                fields: sanctionedFields,
              }
            : activeKey === "pendingapplications"
            ? {
                fields: pendingFields,
              }
            : activeKey === "approved"
            ? {
                fields: approvedFields,
              }
            : activeKey === "rejected"
            ? {
                fields: rejectedFields,
              }
            : { fields: [] })}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(LoanApplicationSearch);
